// extracted by mini-css-extract-plugin
export default {"MONTH":"TKBErF","month":"TKBErF","DAY":"h5hGNS","day":"h5hGNS","YEAR":"ESUU5K","year":"ESUU5K","fields":"Zv5p0U","mobile":"qwZHYD"};